module.exports = __webpack_public_path__ + "static/media/bin.65eae96d.svg";